import React, {Component} from 'react';
import { withRouter } from 'react-router-dom';
import {MainNavBar} from "../mainNavBar/MainNavBar";
import GetTheApp from './assets/GetTheApp-Transparent.png';
import EightOneOne from './assets/811-Transparent.png';
import './HomeHeader.scss';

class HomeHeader extends Component {


  render() {

    const EightOneOneButton = withRouter(({ history }) => (
      <button
        className={'btn'}
        onClick={() => { history.push('/811') }}
      >
        Learn More
      </button>
    ));

    const DownloadButton = withRouter(({ history }) => (
      <button
        className={'btn'}
        onClick={() => { history.push('/states') }}
      >
        Download
      </button>
    ));

    const ExpertsButton = withRouter(({ history }) => (
      <button
        className={'btn'}
        onClick={() => { history.push('/meet-the-experts') }}
      >
        Meet Now
      </button>
    ));

    return (
      <div id="home-header">
        <MainNavBar
          location={this.props.location}
          match={this.props.match}
        />
        <div className="row headerContainer">
          <div style={{background: '#A8A7A8'}} className="col-sm-3 col-xs-12 headerCard">
          </div>
          <div style={{background: '#6F6E6E'}} className="col-sm-3 col-xs-12 headerCard">
            <img className={'headerImage'} src={EightOneOne}/>
            <h4>What's 811?</h4>
            <EightOneOneButton />
          </div>
          <div style={{background: '#A8A7A8'}} className="col-sm-3 col-xs-12 headerCard">
            <img className={'headerImage'} src={GetTheApp}/>
            <h4>Get the Free App</h4>
            <DownloadButton/>
          </div>
          <div style={{background: '#6F6E6E'}} className="col-sm-3 col-xs-12 headerCard">
          </div>
        </div>

      </div>
    );
  }
}

export default HomeHeader;



// WEBPACK FOOTER //
// ./src/components/common/homeHeader/HomeHeader.js